var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewWorkspaceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.038 11.587h-3.317v3.317H9.279v-3.317H5.96v-1.443h3.32V6.827h1.442v3.317h3.317v1.443zm2.308-5.049v8.654h-4.183v-.577h3.606v-7.5h-3.606v-.577h4.183zm-8.51 8.654H3.654V6.538h4.182v.577H4.23v7.5h3.606v.577zm9.664.577a.577.577 0 0 1-.577.577H3.077a.577.577 0 0 1-.577-.577V5.385h15v10.384zM16.923 2.5H3.077a1.73 1.73 0 0 0-1.731 1.73v11.54a1.73 1.73 0 0 0 1.73 1.731h13.847a1.73 1.73 0 0 0 1.73-1.73V4.23a1.73 1.73 0 0 0-1.73-1.731z",
  fill: "#0481A0",
  fillRule: "evenodd"
}))));
export default SvgNewWorkspaceIcon;